function ProductReducer(state = { productList4Select: [], productBugList: [], selectBugModalStatus: '' }, action) {
    switch (action.type) {
        case "SEARCH_PRODUCT_BUG":
            return {
                ...state,
                productBugList: action.data
            }
        case "SET_PBUG_POP":
            return {
                ...state,
                selectBugModalStatus: action.data
            }
        case "SEARCH_PRODUCT_SELECT":
            return {
                ...state,
                productList4Select: action.data
            }
        default:
            return state;
    }
}
export default ProductReducer;